<template>
  <span class="vote-chip-wrap">
    <button
      type="button"
      class="vote-chip"
      :class="{ full: isFull, empty: count === 0 }"
      :aria-label="`${count} of ${total} votes`"
      @click.stop="showList = true"
    >
      <svg class="vote-ring" viewBox="0 0 36 36" aria-hidden="true">
        <circle class="vote-ring-bg" cx="18" cy="18" r="15.5" />
        <circle
          class="vote-ring-fg"
          cx="18"
          cy="18"
          r="15.5"
          :stroke-dasharray="circumference"
          :stroke-dashoffset="dashOffset"
        />
      </svg>
      <span class="vote-count">{{ count }}/{{ total }}</span>
    </button>

    <ModalDialog
      :show="showList"
      type="list"
      title="Who has voted"
      :names="voterNames"
      confirmText="Close"
      @confirm="showList = false"
      @cancel="showList = false"
    />
  </span>
</template>

<script>
import ModalDialog from "@/components/Modal.vue";
import { getVoters } from "@/utils/votes";

export default {
  name: "VoteChip",
  components: { ModalDialog },
  props: {
    instanceData: {
      type: Object,
      required: true
    },
    thingId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showList: false,
      circumference: 2 * Math.PI * 15.5
    };
  },
  computed: {
    total() {
      return this.instanceData.names?.length || 0;
    },
    voters() {
      return getVoters(this.instanceData.names, this.instanceData.rankings, this.thingId);
    },
    count() {
      return this.voters.length;
    },
    isFull() {
      return this.total > 0 && this.count >= this.total;
    },
    dashOffset() {
      const ratio = this.total > 0 ? Math.min(this.count / this.total, 1) : 0;
      return this.circumference * (1 - ratio);
    },
    voterNames() {
      return this.voters.map((person) => person.name);
    }
  }
};
</script>

<style scoped>
.vote-chip-wrap {
  display: inline-flex;
  flex-shrink: 0;
}

.vote-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 4px 8px 4px 4px;
  border: 1px solid #ddd;
  border-radius: 999px;
  background: #fff;
  color: #333;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.vote-chip.empty {
  color: #888;
}

.vote-chip.full {
  border-color: #27ae60;
  background: #f3fbf6;
  color: #1e8449;
}

.vote-ring {
  width: 22px;
  height: 22px;
  transform: rotate(-90deg);
}

.vote-ring-bg,
.vote-ring-fg {
  fill: none;
  stroke-width: 3.5;
}

.vote-ring-bg {
  stroke: #e0e0e0;
}

.vote-ring-fg {
  stroke: #3498db;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.2s ease;
}

.vote-chip.full .vote-ring-fg {
  stroke: #27ae60;
}
</style>
